import { render, staticRenderFns } from "./AddToMap.vue?vue&type=template&id=20834944&scoped=true&"
import script from "./AddToMap.vue?vue&type=script&lang=js&"
export * from "./AddToMap.vue?vue&type=script&lang=js&"
import style0 from "../../Auth/AuthModal/AuthModal.scss?vue&type=style&index=0&id=20834944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20834944",
  null
  
)

export default component.exports